export default __webpack_public_path__ + "assets/court-outline-92e5f21062da605edefbf541265f2e00.png";